export default "__VITE_ASSET__D7j2HpTo__"